<template>
    <div id="qb-custom-template-id-friendly" class="bg-white rounded-lg m-auto w-100 min-vh-100 pb-5" v-if="setting">
<!--        <div class="py-5 px-4">-->
<!--            <div class="row p-0 m-0" v-if="setting.logo.placement == 'left'">-->
<!--                <div class="col-4 p-0 m-0" v-if="setting.logo.url && setting.logo.show">-->
<!--                    <div :class="'float-left qp-'+setting.logo.size+'-logo'" :style="'background-repeat: no-repeat;background-size: contain;background-image:url('+setting.logo.url+');'"></div>-->
<!--                </div>-->
<!--                <div class="col-4 p-0 m-0">-->
<!--                    <p class="text-xl text-center font-weight-bold" :style="'color:'+textColor+';'">Quote</p>-->
<!--                </div>-->
<!--                <div class="col-4 p-0 m-0 text-right">-->
<!--                    <p class="text-xl font-weight-bold">Advanced Sandbox Company US</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">123 Sierra Way</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">San Pablo, CA 87999</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">noreply@followupcrm.com</p>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="row p-0 m-0" v-else-if="setting.logo.placement == 'center'">-->
<!--                <div class="col-4 p-0 m-0">-->
<!--                    <p class="text-xl font-weight-bold">Advanced Sandbox Company US</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">123 Sierra Way</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">San Pablo, CA 87999</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">noreply@followupcrm.com</p>-->
<!--                </div>-->
<!--                <div class="col-4 p-0 m-0" v-if="setting.logo.url && setting.logo.show">-->
<!--                    <div :class="'qp-'+setting.logo.size+'-logo'" :style="'margin:0 auto;background-repeat: no-repeat;background-size: contain;background-image:url('+setting.logo.url+');'"></div>-->
<!--                </div>-->
<!--                <div class="col-4 p-0 m-0 text-right">-->
<!--                    <p class="text-xl text-right font-weight-bold" :style="'color:'+textColor+';'">Quote</p>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="row p-0 m-0" v-else>-->
<!--                <div class="col-4 p-0 m-0">-->
<!--                    <p class="text-xl font-weight-bold">Advanced Sandbox Company US</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">123 Sierra Way</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">San Pablo, CA 87999</p>-->
<!--                    <p :style="'font-size:'+this.setting.font.size+';'">noreply@followupcrm.com</p>-->
<!--                </div>-->
<!--                <div class="col-4 p-0 m-0">-->
<!--                    <p class="text-xl text-center font-weight-bold" :style="'color:'+textColor+';'">Quote</p>-->
<!--                </div>-->
<!--                <div class="col-4 p-0 m-0" v-if="setting.logo.url && setting.logo.show">-->
<!--                    <div :class="'float-right qp-'+setting.logo.size+'-logo'" :style="'background-repeat: no-repeat;background-size: contain;background-image:url('+setting.logo.url+');'"></div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="py-5 px-4">
            <div class="row p-0 m-0" v-if="setting.logo.placement == 'left'">
                <div class="col-6 p-0 m-0" v-if="setting.logo.url && setting.logo.show">
                    <div :class="'float-left qp-'+setting.logo.size+'-logo'" :style="'background-repeat: no-repeat;background-size: contain;background-image:url('+setting.logo.url+');'"></div>
                </div>
                <div class="col-6 p-0 m-0 text-right">
                    <div class=" pgQuoteProjectDiv" style="float: right;width: 75%;" @click="setFocusedEditor('PGQuoteProject')">
                        <ckeditor-container
                            editorKey="pgQuoteProject"
                            placeholder=""
                            id="projectDataRight"
                            v-model="projectData"
                            :options="[]"
                            @mention="addMention"
                            mentionFrom="name"
                            ref="PGQuoteProject"
                            @input="contentAdded"
                        ></ckeditor-container>
                    </div>
                </div>
            </div>
            <div class="row p-0 m-0" v-else-if="setting.logo.placement == 'center'">
                <div class="col-12 p-0 m-0 mb-3" v-if="setting.logo.url && setting.logo.show">
                    <div :class="'qp-'+setting.logo.size+'-logo'" :style="'margin:0 auto;background-repeat: no-repeat;background-size: contain;background-image:url('+setting.logo.url+');'"></div>
                </div>
                <div class="col-12 p-0 m-0">
                    <div class="w-50 pgQuoteProjectDiv" @click="setFocusedEditor('PGQuoteProject')">
                        <ckeditor-container
                            editorKey="pgQuoteProject"
                            placeholder=""
                            id="projectDataCenter"
                            v-model="projectData"
                            :options="[]"
                            @mention="addMention"
                            mentionFrom="name"
                            ref="PGQuoteProject"
                            @input="contentAdded"
                        ></ckeditor-container>
                    </div>
                </div>
            </div>
            <div class="row p-0 m-0" v-else>
                <div class="col-6 p-0 m-0">
                    <div class="w-75 pgQuoteProjectDiv" @click="setFocusedEditor('PGQuoteProject')">
                        <ckeditor-container
                            editorKey="pgQuoteProject"
                            placeholder=""
                            id="projectDataLeft"
                            v-model="projectData"
                            :options="[]"
                            @mention="addMention"
                            mentionFrom="name"
                            ref="PGQuoteProject"
                            @input="contentAdded"
                        ></ckeditor-container>
                    </div>
                </div>
                <div class="col-6 p-0 m-0" v-if="setting.logo.url && setting.logo.show">
                    <div :class="'float-right qp-'+setting.logo.size+'-logo'" :style="'background-repeat: no-repeat;background-size: contain;background-image:url('+setting.logo.url+');'"></div>
                </div>
            </div>
            <div class="row p-0 m-0 mt-4">
                <div class="col-6 p-0 m-0">
                    <div class="w-75 pgQuoteCompany" @click="setFocusedEditor('PGQuoteCompany')">
                        <ckeditor-container
                            editorKey="pgQuoteCompany"
                            placeholder=""
                            id="comment"
                            v-model="companyData"
                            :options="[]"
                            @mention="addMention"
                            mentionFrom="name"
                            ref="PGQuoteCompany"
                            @input="contentAdded"
                        ></ckeditor-container>
                    </div>
                </div>
                <div class="col-6 p-0 m-0">
                    <div class="w-75 pgQuoteCompany float-right" @click="setFocusedEditor('PGQuoteSales')">
                        <ckeditor-container
                            editorKey="pgQuoteSales"
                            placeholder=""
                            id="salesRepData"
                            v-model="salesRepData"
                            :options="[]"
                            @mention="addMention"
                            mentionFrom="name"
                            ref="PGQuoteSales"
                            @input="contentAdded"
                        ></ckeditor-container>
                    </div>
                </div>
            </div>
            <div class="row p-0 m-0 mt-4" style="display: none;">
                <div class="col-12 p-0 m-0">
                    <p :style="'font-size:'+this.setting.font.size+';'"><b>Crew #</b></p>
                    <p :style="'font-size:'+this.setting.font.size+';'">Custom-1</p>
                </div>
            </div>
        </div>

<!--        <div class="border-t-1 mx-4 overflow-hidden margin-auto mb-4" :style="'width: 95%;border-color:'+textColor+' !important;'">-->
<!--            <div class="row px-3 p-0" :style="'font-size:'+this.setting.font.size+';'">-->
<!--&lt;!&ndash;                <div class="col-3 py-1 font-weight-bold">ADDRESS</div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="col-3 py-1 font-weight-bold">SHIP TO</div>&ndash;&gt;-->
<!--                <div class="col-3 py-1 font-weight-bold" :style="'color:'+textColor+';background-color:'+backgroundColor+';'">DATE</div>-->
<!--                <div class="col-3 py-1 font-weight-bold" :style="'color: #ffffff;background-color:'+textColor+';'">PLEASE PAY</div>-->
<!--                <div class="col-3 py-1 font-weight-bold" :style="'color:'+textColor+';background-color:'+backgroundColor+';'">EXPIRATION DATE</div>-->
<!--            </div>-->

<!--            <div class="row px-3 p-0" :style="'font-size:'+this.setting.font.size+';'">-->
<!--&lt;!&ndash;                <div class="col-3 py-1">Smith Co. <br> 123 Main Street <br> City, CA 1234</div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="col-3 py-1">John Smith <br> 20637 Palm Drive <br> City, CA 1234</div>&ndash;&gt;-->
<!--                <div class="col-3 py-1" :style="'color:'+textColor+';background-color:'+backgroundColor+';'">12/02/2016</div>-->
<!--                <div class="col-3 py-1" :style="'color: #ffffff;background-color:'+textColor+';'">$665.0</div>-->
<!--                <div class="col-3 py-1" :style="'color:'+textColor+';background-color:'+backgroundColor+';'">12/02/2016</div>-->
<!--            </div>-->
<!--        </div>-->

        <div class="mx-4 overflow-hidden margin-auto mb-4" style="width: 95%;display: none;">
            <div class="row px-3 py-1 " :style="'font-size:'+this.setting.font.size+';'">
                <div class="col font-weight-bold" >SHIP DATE</div>
                <div class="col font-weight-bold" >SHIP VIA</div>
                <div class="col font-weight-bold" >TRACKING NO.</div>
                <div class="col font-weight-bold" >CREW#</div>
            </div>

            <div class="row px-3 py-1" :style="'font-size:'+this.setting.font.size+';'">
                <div class="col">12/01/2016</div>
                <div class="col">FedEx</div>
                <div class="col">12345678</div>
                <div class="col">CUSTOM-1</div>
            </div>
        </div>

        <div class="mx-4 overflow-hidden margin-auto" style="width: 95%;">
            <div class="row px-3 py-1 border-b-1 border-t-1 border-grey-darker" :style="'font-size:'+this.setting.font.size+';'">
<!--                <div class="col font-weight-bold " >DATE</div>-->
                <div class="col font-weight-bold " >ACTIVITY</div>
                <div class="col-5 font-weight-bold " >DESCRIPTION</div>
                <div class="col font-weight-bold " >QTY</div>
                <div class="col font-weight-bold " >RATE</div>
                <div class="col font-weight-bold" >AMOUNT</div>
            </div>

            <div class="row px-3 py-1" :style="'font-size:'+this.setting.font.size+';'">
<!--                <div class="col ">12/01/2016</div>-->
                <div class="col ">Item name</div>
                <div class="col-5 ">Description of item</div>
                <div class="col ">2</div>
                <div class="col ">225.00</div>
                <div class="col">450.00</div>
            </div>
            <div class="row px-3 py-1" :style="'font-size:'+this.setting.font.size+';'">
<!--                <div class="col ">12/01/2016</div>-->
                <div class="col ">Item name</div>
                <div class="col-5 ">Description of item</div>
                <div class="col ">2</div>
                <div class="col ">225.00</div>
                <div class="col">450.00</div>
            </div>
        </div>

        <div class="container mt-5">
            <div class="row border-1">
            </div>
        </div>

        <div class="container mt-4" :style="'font-size:'+this.setting.font.size+';'">
            <div class="row p-0 m-0">
                <div class="col-8">
                    <div class="pgQuoteProjectDiv w-75" @click="setFocusedEditor('PGQuoteSignature')">
                        <ckeditor-container
                            editorKey="pgQuoteSignature"
                            placeholder=""
                            id="signatureData"
                            v-model="signatureData"
                            :options="[]"
                            @mention="addMention"
                            mentionFrom="name"
                            ref="PGQuoteSignature"
                            @input="contentAdded"
                        ></ckeditor-container>
                    </div>
                </div>
                <div class="col-4">
                    <div class="row p-0 m-0">
                        <div class="col-6" :style="'color:'+textColor+';'">
                            SUBTOTAL
                        </div>
                        <div class="col-6 text-right">
                            675.00
                        </div>
                    </div>
                    <div class="row p-0 m-0">
                        <div class="col-6" :style="'color:'+textColor+';'">
                            DISCOUNT 2%
                        </div>
                        <div class="col-6 text-right">
                            -13.50
                        </div>
                    </div>
                    <div class="row p-0 m-0">
                        <div class="col-6" :style="'color:'+textColor+';'">
                            TOTAL TAX
                        </div>
                        <div class="col-6 text-right">
                            101.25
                        </div>
                    </div>
                    <div class="row p-0 m-0">
                        <div class="col-6" :style="'color:'+textColor+';'">
                            SHIPPING
                        </div>
                        <div class="col-6 text-right">
                            3.50
                        </div>
                    </div>

                    <div class="row p-0 m-0 mt-2 border-t-1 border-grey-darker" :style="'border-bottom: 1px solid '+textColor+';'">
                        <div class="col-6 pt-2 pb-2" :style="'color:'+textColor+';'">
                            Bid Due
                        </div>
                        <div class="col-6 text-lg font-weight-bold text-right pt-1 pb-1" :style="'color:'+textColor+';'">
                            $776.25
                        </div>
                    </div>
<!--                    <div class="row p-0 m-0 mt-1">-->
<!--                        <div class="col-12 text-right"  :style="'color:'+textColor+';'">-->
<!--                            THANK YOU-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import CkeditorContainer from "../../../../shared/ckeditor-container.vue";

export default {
    name: "friendly-quote-pricing-template",
    props:['templateSetting', 'sectionData'],
    components: {CkeditorContainer},
    data() {
        return {
            setting: null,
            textColor: '',
            backgroundColor: '',
            selectedFont: null,
            projectData: null,
            companyData: null,
            salesRepData: null,
            signatureData: null,
            focusedEditorKey: null,
        }
    },
    mounted(){
        this.setting = this.templateSetting;
        this.fetchSectionData();
        this.textColor = this.templateSetting.color;
        this.backgroundColor = this.hexToRgba(this.templateSetting.color, 15);
        if(this.templateSetting.font.style){
            this.selectedFont = this.templateSetting.font.style.replace(/ /g, "%20");
        }
        this.loadGoogleFonts();
        Bus.$on('valueUpdatedQBTemplates', (data) => {
            this.valuesUpdated(data);
        });

        Bus.$on('pgQuoteSettingField', (data) => {
            this.$refs[this.focusedEditorKey].addField(data);
        });

        Bus.$on('updateSectionContent', (data) => {
            this.projectData = data.projectData;
            this.companyData = data.companyData;
            this.salesRepData = data.salesRepData;
            this.signatureData = data.signatureData;
        });
    },
    methods: {
        hexToRgba(hex, alpha = 15) {
            hex = hex.replace(/^#/, '');
            let r = parseInt(hex.substring(0, 2), 16);
            let g = parseInt(hex.substring(2, 4), 16);
            let b = parseInt(hex.substring(4, 6), 16);
            return `rgb(${r},${g},${b},${alpha}%)`;
        },
        valuesUpdated(settingValue){
            this.setting = settingValue;
            this.textColor = settingValue.color;
            this.backgroundColor = this.hexToRgba(settingValue.color, 15);
            if(settingValue.font.style){
                this.selectedFont = settingValue.font.style.replace(/ /g, "%20");
                this.$nextTick(() => {
                    this.loadGoogleFonts();
                })
            }else{
                const linkElement = document.getElementById('qp-google-fonts-stylesheet');
                if (linkElement) {
                    linkElement.parentNode.removeChild(linkElement);
                }

                const styleElement = document.getElementById('qb-googleFont-id-style');
                if (styleElement) {
                    styleElement.parentNode.removeChild(styleElement);
                }
            }
        },
        loadGoogleFonts() {
            const linkElement = document.getElementById('qp-google-fonts-stylesheet');
            if (linkElement) {
                linkElement.parentNode.removeChild(linkElement);
            }
            if(this.selectedFont) {
                const link = document.createElement('link');
                link.href = 'https://fonts.googleapis.com/css2?family=' + this.selectedFont;
                link.rel = 'stylesheet';
                link.id = 'qp-google-fonts-stylesheet';
                document.head.appendChild(link);

                let customClass = 'googleFont-'+this.setting.font.style.replace(/ /g, "");
                $('#qb-custom-template-id-friendly').addClass(customClass);
                this.addCustomStyles(customClass)
            }
        },
        addCustomStyles(customClass) {
            const sElement = document.getElementById('qb-googleFont-id-style');
            if (sElement) {
                sElement.parentNode.removeChild(sElement);
            }
            const styleElement = document.createElement('style');
            styleElement.setAttribute('scoped', '');
            styleElement.setAttribute('id', 'qb-googleFont-id-style');
            styleElement.textContent = `.`+customClass+` * {font-family: "`+this.setting.font.style+`" !important;}`;
            this.$el.appendChild(styleElement);
        },
        setFocusedEditor(editorKey) {
            this.focusedEditorKey = editorKey;
        },
        contentAdded(){
            this.$nextTick(() => {
                let data = {
                    projectData: this.projectData,
                    companyData: this.companyData,
                    salesRepData: this.salesRepData,
                    signatureData: this.signatureData,
                };
                this.$parent.contentAdded(data);
                Bus.$emit('updateSectionContent', data);
            });
        },
        fetchSectionData(){
            this.$nextTick(() => {
                if(this.sectionData){
                    console.log(this.sectionData);
                    this.projectData = this.sectionData.projectData;
                    this.companyData = this.sectionData.companyData;
                    this.salesRepData =  this.sectionData.salesRepData;
                    this.signatureData =  this.sectionData.signatureData;
                }
            })

        },
        addMention(){

        },
    },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family={{ selectedFont }}');

*{
    color: #3d4852
}
.qp-small-logo {
    width: 180px;
    height: 151px
}
.qp-medium-logo {
    width: 220px;
    height: 185px
}
.qp-large-logo {
    width: 260px;
    height: 218px
}
</style>
